<form class="edit-form" *ngIf="!isLoading && clients" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.sites.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'repository.sites.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-autocomplete [control]="getControl('client')" [list]="clients" label="repository.sites.edit.client.label"
    errorMsg="repository.sites.edit.client.errorMessage">
  </app-autocomplete>

  <mat-checkbox *ngIf="site && site.otherSite" formControlName="otherSite">{{'repository.sites.edit.otherSite.label' |
    translate}}</mat-checkbox>

  <mat-form-field>
    <mat-label>{{ 'repository.sites.edit.documentUrl.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="documentUrl">
    <mat-error>{{ 'repository.sites.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>